import AxiosMockAdapter from 'axios-mock-adapter';

import instance from '@/utils/http';

import mock from './balance-finance.mock.json';

const debtsMock = [
  { consumerType: 'Household', debt: 1000000000, debtorsCount: 1500000 },
  { consumerType: 'Commercial', debt: 500000000, debtorsCount: 10000 },
];

const settlementsMock = [
  {
    consumerType: 'Household',
    charged: 560000,
    paid: 150000,
    overpayment: 175000,
    debt: 80000,
  },
  {
    consumerType: 'Commercial',
    charged: 780000,
    paid: 380000,
    overpayment: 900000,
    debt: 120000,
  },
];

const adapter = new AxiosMockAdapter(instance);

adapter
  .onGet(/\/api\/balance-finance\/debts-chart.*/)
  .reply(200, debtsMock)
  .onGet(/\/api\/balance-finance\/settlements-chart.*/)
  .reply(200, settlementsMock)
  .onGet(/\/api\/balance-finance.*/)
  .reply(200, mock)
  .onAny()
  .passThrough();
